import MeetFromPlants, { MeetFromPlantsProps } from "./MeetFromPlants";

export { MeetFromPlants, MeetFromPlantsProps };

export default MeetFromPlants;
